export default "__VITE_ASSET__cbd5e9e7__"